<script>
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import _throttle from 'lodash/throttle'

export default {
  components: { TheHeader, TheFooter },
  props: {
    type: {
      type: String,
      default: 'default',
      validator(value) {
        return ['default', 'liff', 'brand'].includes(value)
      },
    },
    brandContact: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      scrollTop: 0,
      onScroll: _throttle(() => {
        this.scrollTop = this.getWindowScrollTop()
      }, 200),
    }
  },
  computed: {
    isDefaultLayout() {
      return this.type === 'default' || this.type === 'brand'
    },
  },
  created() {
    // if(!this.$store.state.global.menuSolution.length
    //   && !this.$store.state.global.menuProduct.length
    //   && !this.$store.state.global.menuBrand.length
    // ) {
    this.fetchMenu()
    // }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    async fetchMenu() {
      const vm = this
      await vm.$store.dispatch('option/fetchOptionList', {
        types: ['product_parent_category', 'brand'],
        useCached: true,
      })
    },
    scrollToTop() {
      const c = document.documentElement.scrollTop || document.body.scrollTop
      if (c > 0) {
        window.requestAnimationFrame(this.scrollToTop)
        window.scrollTo(0, c - c / 8)
      }
    },
    getWindowScrollTop() {
      let windowScrollTop = 0
      if (typeof window.pageYOffset !== 'undefined') {
        windowScrollTop = window.pageYOffset
      } else if (typeof document.compatMode !== 'undefined' && document.compatMode !== 'BackCompat') {
        windowScrollTop = document.documentElement.scrollTop
      } else if (typeof document.body !== 'undefined') {
        windowScrollTop = document.body.scrollTop
      }
      return windowScrollTop
    },
    onMobileMenuOpen(val) {
      this.$emit('mobileOpen', val)
    },
  },
}
</script>

<template>
  <div :class="[$style.layout]">
    <TheHeader :type="type" class="header" />
    <slot />
    <TheFooter v-if="isDefaultLayout" @mobileOpen="onMobileMenuOpen" />
    <BaseButton v-if="isDefaultLayout" :class="[$style.scrollToTop, { [$style.isHidden]: scrollTop < 500 }]" class="isStylePrimary isOutline isCircle d-md-block d-none" @click="scrollToTop">
      <i class="fal fa-chevron-up"></i>
    </BaseButton>
  </div>
</template>
<style lang="scss" module>
.layout {
  :global {
  }
}

.scrollToTop {
  position: fixed;
  right: 25px;
  bottom: 11rem;
  z-index: 99;
  width: 60px !important;
  height: 36px !important;
  font-size: 1rem;
  border-radius: 7px !important;
  opacity: 1;
  transition: all 0.3s !important;

  &:hover {
    color: #fff !important;
    // background: none;
    background-color: $color-primary !important;
    // border-color: $color-primary !important;
  }

  &.isHidden {
    opacity: 0;
  }
}
</style>
